import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import TenantEditForm from '@src/features/tenant/tenants/TenantEditForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function TenantsEdit() {
  return (
    <TenantRoleGuard canRoles={[TENANT_ROLE.ADMIN]}>
      <TenantDefaultLayout>
        <CommonHelmet />
        <TenantEditForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default TenantsEdit;
